// What a stage, a phase or a span of time is called on screen.
//
// The stored values are not the words. A truck standing in the yard is recorded as YARD and shown as
// Parking, because that is what the people on site call the area it is waiting in. Renaming the
// record instead would rewrite every trip ever run, break the imports that name the old value, and
// change URLs people have bookmarked - for a change that is about wording.
//
// So the codes stay and this is the one place that decides what they read as.

const WORDS = {
  YARD: 'Parking',
  AT_YARD: 'In parking',
};

/** A stored code as a person would say it. */
export const inWords = (value) => WORDS[value]
  || value?.replaceAll('_', ' ').toLowerCase().replace(/^./, (c) => c.toUpperCase())
  || 'Unknown';

/**
 * A number of minutes as hours and minutes.
 *
 * "437 min" is a figure somebody has to do arithmetic on before it means anything, and a mean
 * turnaround is read at a glance by people deciding whether today is going badly. Under an hour it
 * stays in minutes rather than printing "0h 42m", which reads as a fault.
 */
export const hoursAndMinutes = (minutes) => {
  if (minutes == null || !Number.isFinite(Number(minutes))) return '—';
  const total = Math.max(0, Math.round(Number(minutes)));
  const hours = Math.floor(total / 60);
  const rest = total % 60;
  if (!hours) return `${rest}m`;
  return rest ? `${hours}h ${rest}m` : `${hours}h`;
};
